/* eslint-disable */
/*
 * VENDORED, DO NOT EDIT.
 * Source: universal-fingerprint-codec (https://github.com/MDS-BD/universal-fingerprint-codec),
 * package @mds-bd/universal-fingerprint-codec 0.2.0, file ts/dist/index.js (ESM build, wire v1).
 * Vendored because the Amplify build runs a plain `npm ci` without GitHub Packages credentials.
 * Refresh: `pnpm build:ts` in the codec repo, copy ts/dist/index.js here, drop the
 * sourceMappingURL line and keep this header. Conformance: codec.test.js (vitest)
 * against test-vectors.json, copied from the same release.
 */
// src/index.ts
var ESC = "~";
var SEP = "=";
var FORMAT_ID = "universal-fingerprint/kv";
var FORMAT_VERSION = 1;
var SPEC_DIGEST = "sha256:275e7ce49568775de3c448a34954a2b6b593e9b4dbfa5e2153ea65c1a6fb33ca";
var SUPPORTED_FORMAT_VERSIONS = Object.freeze([FORMAT_VERSION]);
function specDigest(formatVersion) {
  return formatVersion === FORMAT_VERSION ? SPEC_DIGEST : void 0;
}
var UNICODE_WS = /* @__PURE__ */ new Set([
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
]);
var needsHex = (cp) => cp <= 31 || cp === 127 || UNICODE_WS.has(cp);
function esc(s) {
  let out = "";
  for (const ch of s) {
    const cp = ch.codePointAt(0);
    if (ch === ESC) out += ESC + ESC;
    else if (ch === " ") out += ESC + "_";
    else if (ch === SEP) out += ESC + "e";
    else if (needsHex(cp)) out += ESC + "u" + cp.toString(16).toUpperCase() + ESC;
    else out += ch;
  }
  return out;
}
function unesc(s) {
  let out = "";
  let i = 0;
  while (i < s.length) {
    const ch = s[i];
    if (ch !== ESC) {
      out += ch;
      i++;
      continue;
    }
    if (i + 1 >= s.length) throw new Error("token malformato: escape troncato a fine stringa");
    const d = s[i + 1];
    if (d === ESC) {
      out += ESC;
      i += 2;
    } else if (d === "_") {
      out += " ";
      i += 2;
    } else if (d === "e") {
      out += SEP;
      i += 2;
    } else if (d === "u") {
      const j = s.indexOf(ESC, i + 2);
      if (j < 0) throw new Error("token malformato: sequenza ~u non terminata");
      out += String.fromCodePoint(parseInt(s.slice(i + 2, j), 16));
      i = j + 1;
    } else {
      throw new Error(`token malformato: designatore sconosciuto '${ESC}${d}'`);
    }
  }
  return out;
}
function encode(key, value) {
  return esc(key) + SEP + esc(value);
}
function decode(token) {
  const idx = token.indexOf(SEP);
  if (idx < 0) throw new Error(`token privo di separatore '${SEP}': ${JSON.stringify(token)}`);
  return [unesc(token.slice(0, idx)), unesc(token.slice(idx + 1))];
}
function normalizeValue(value) {
  if (value === true) return "True";
  if (value === false) return "False";
  if (typeof value !== "string") {
    throw new TypeError(`normalizeValue accetta string o boolean, non ${typeof value}`);
  }
  if (value === "true") return "True";
  if (value === "false") return "False";
  return value;
}
function toPair(item) {
  if (typeof item === "string") {
    const idx = item.indexOf(SEP);
    if (idx < 0) throw new Error(`item stringa senza '${SEP}': ${JSON.stringify(item)}`);
    return { key: item.slice(0, idx), value: item.slice(idx + 1), boost: 1 };
  }
  if (Array.isArray(item)) {
    return { key: item[0], value: item[1], boost: item[2] ?? 1 };
  }
  const obj = item;
  return { key: obj.key, value: obj.value, boost: obj.boost ?? 1 };
}
function encodeFingerprint(items) {
  const tokens = [];
  for (const item of items) {
    const { key, value, boost } = toPair(item);
    const tok = encode(key, value);
    for (let i = 0; i < Math.max(1, boost); i++) tokens.push(tok);
  }
  return tokens.join(" ");
}
function decodeFingerprint(text) {
  const out = [];
  for (const tok of text.split(" ")) {
    if (!tok) continue;
    const [key, value] = decode(tok);
    out.push({ key, value });
  }
  return out;
}
var SEPARATOR = SEP;
var ESCAPE = ESC;
export {
  ESCAPE,
  FORMAT_ID,
  FORMAT_VERSION,
  SEPARATOR,
  SPEC_DIGEST,
  SUPPORTED_FORMAT_VERSIONS,
  decode,
  decodeFingerprint,
  encode,
  encodeFingerprint,
  normalizeValue,
  specDigest
};
